/**
 * Texts for Notifications page
 */
export const notificationsPageText = {
    title: 'Latest in-app notifications',
    titleMeta: 'Shows recent in-app notifications from CamAPS FX',
    descriptionMeta: 'Here you will find the text of the latest in-app notifications for app updates, security notifications and user manual updates',
    keywords: 'Notifications' ,
    localeMeta: 'en_gb',

    heading: 'Latest in-app notifications',
    subheading: '',

    header_133:'',
    body_133:'',

    header_132:'Android app update (YpsoPump only) 28/10/2026',
    body_132:'Dear CamAPS FX user, a new version of CamAPS FX, 1.4(195), will be available in the next few days. To choose when to update, please DEACTIVATE AUTOMATIC UPDATES in the App Store. For any questions, please contact mylife-Diabetescare Customer Service.',

    header_131:'',
    body_131:'',

    header_130:'Update required (YpsoPump only) 20/10/2026',
    body_130:'Update required! This version of CamAPS FX may crash and restart more often. Please update to the latest version NOW via the Google Play Store. App version 1.4(190) will be discontinued on 20/11/2026. After this date, “Auto Mode” will no longer be available until the app is updated. Insulin delivery via your pump will continue.',

    header_129:'iOS app update (YpsoPump only) 19/10/2026',
    body_129:'Dear CamAPS FX user, a new version of CamAPS FX, 1.4(196), will be available in the next few days. To choose when to update, please DEACTIVATE AUTOMATIC UPDATES in the App Store. For any questions, please contact mylife-Diabetescare Customer Service.',

    header_128:'',
    body_128:'',

    header_127:'',
    body_127:'',

    header_126:'',
    body_126:'',

    header_125:'',
    body_125:'',

    header_124:'',
    body_124:'',

    header_123:'',
    body_123:'',

    header_122:'',
    body_122:'',

    header_121:'Apple iOS 27 release 11/09/2026',
    body_121:'Apple will soon release iOS 27. To ensure uninterrupted use of the CamAPS FX application, please check the sensor manufacturer\'s website to verify smartphone and operating system compatibility BEFORE updating your iPhone to iOS 27. Automatic updates might be turned ON in your phone\'s settings by default, please consider turning these OFF.',

    header_120:'',
    body_120:'',

    header_119:'',
    body_119:'',

    header_118:'',
    body_118:'',

    header_117:'Android app update (YpsoPump only) 31/08/2026',
    body_117:'Dear CamAPS FX user, a new version of CamAPS FX, 1.4(193), will be available in the next few days. To choose when to update, please DEACTIVATE AUTOMATIC UPDATES in the App Store. For any questions, please contact mylife-Diabetescare Customer Service.',

    header_116:'',
    body_116:'',

    header_115:'',
    body_115:'',

    header_114:'',
    body_114:'',

    header_113:'',
    body_113:'',

    header_112:'',
    body_112:'',

    header_111:'',
    body_111:'',

    header_110:'',
    body_110:'',
    body_110_link_text:'',
    body_110_end: '',
    body_110_link:'',

    header_109:'Android OS 17 release 24/06/2026',
    body_109:'Android will soon release OS 17. To ensure uninterrupted use of the CamAPS FX application, please check the sensor manufacturer\'s website to verify smartphone and operating system compatibility BEFORE updating your Android to OS 17. Automatic updates might be turned ON in your phone\'s settings by default, please turn these OFF.',

    header_108:'',
    body_108:'',

    header_107:'',
    body_107:'',

    header_106:'',
    body_106:'',

    header_105:'',
    body_105:'',

    header_104:'',
    body_104:'',

    header_103:'',
    body_103:'',

    header_102:'',
    body_102:'',

    header_101:'',
    body_101:'',

    header_100:'',
    body_100:'',

    header_99:'',
    body_99:'',

    header_98:'',
    body_98:'',

    header_97:'',
    body_97:'',

    header_96:'',
    body_96:'',

    header_95:'',
    body_95:'',

    header_94:'',
    body_94:'',

    header_93:'',
    body_93:'',

    header_92:'',
    body_92:'',

    header_91:'',
    body_91:'',
    body_91_link_text:'',
    body_91_end: '',
    body_91_link:'',

    header_90:'',
    body_90:'',

    header_89:'',
    body_89:'',

    header_88:'',
    body_88:'',

    header_87:'',
    body_87:'',

    header_86:'',
    body_86:'',
    body_86_link_text:'',
    body_86_end: '',
    body_86_link:'',

    header_85:'User manual update (Ypsopump only) 25/02/2026',
    body_85:'An updated version of the user manual is now available. You can access it from the CamAPS FX main menu and selecting Help.',

    header_84:'FreeStyle Libre 3 Pus and iOS availability (YpsoPump only 23/02/2026)',
    body_84:'FreeStyle Libre 3 Plus is now available for use with the CamAPS FX app in Canada. To see this option in the app, please re-pair your mylife YpsoPump with the CamAPS FX app. CamAPS FX is now also available on iPhone. If you have any questions, please contact mylife Diabetescare Customer Care.',

    header_83:'Android app update (Ypsopump only) 16/02/2026',
    body_83:'Dear CamAPS FX user, a NEW VERSION of the application will be available in the next few days - 1.4(190). DEACTIVATE CamAPS FX AUTOMATIC UPDATES in Google Play Store to select your preferred update time. For cybersecurity reasons, versions BELOW 1.4(190) will be DISCONTINUED on 31st March. If you have any questions, please contact mylife-Diabetescare Customer Service.',

    header_82:'',
    body_82:'',

    header_81:'',
    body_81:'',

    header_80:'',
    body_80:'',

    header_79:'',
    body_79:'',

    header_78:'',
    body_78:'',

    header_77:'',
    body_77:'',

    header_76:'Dexcom announcement from mylife-Diabetescare (YpsoPump only) 15/12/2025',
    body_76:'Dexcom has announced that it will gradually phase out the Dexcom G6 and transition more users to its newer G7 system. For now, your Dexcom G6 remains fully supported, no action is needed at this time. You will continue to have sensor options as technology evolves. If you have questions, we\'re here to help.',

    header_75:'',
    body_75:'',

    header_74:'',
    body_74:'',

    header_73:'',
    body_73:'',
    body_73_link_text:'',
    body_73_end: '',
    body_73_link:'',

    header_72:'',
    body_72:'',
    body_72_link_text:'',
    body_72_end: '',
    body_72_link:'',

    header_71:'',
    body_71:'',
    body_71_link_text:'',
    body_71_end: '',
    body_71_link:'',

    header_70:'',
    body_70:'',
    body_70_link_text:'',
    body_70_end: '',
    body_70_link:'',
	
    header_69:'',
    body_69:'',
	
    header_68:'',
    body_68:'',
	
    header_67:'',
    body_67:'',

    header_66:'',
    body_66:'',
    body_66_link_text:'',
    body_66_end: '',
    body_66_link:'',

    header_65:'',
    body_65:'',
    body_65_link_text:'',
    body_65_end: '',
    body_65_link:'',

    header_64:'',
    body_64:'',
    body_64_link_text:'',
    body_64_end: '',
    body_64_link:'',

    header_63:'',
    body_63:'',
    body_63_link_text:'',
    body_63_end: '',
    body_63_link:'',

    header_62:'',
    body_62:'',
    body_62_link_text:'',
    body_62_end: '',
    body_62_link:'',

    header_61:'',
    body_61:'',

    header_60:'',
    body_60:'',

    header_59:'',
    body_59:'',

    header_58:'',
    body_58:'',

    header_57:'',
    body_57:'',

    header_56:'',
    body_56:'',

    header_55:'Android OS 16 15/08/2025',
    body_55:'Note: CamAPS FX is not currently compatible with Android OS 16. To ensure uninterrupted use of the app, please check the FAQ on camdiab.com/en-ca to verify smartphone and operating system compatibility before updating to Android OS 16. Attention: automatic updates might be turned on in your phone\'s settings by default.',

    header_54:'',
    body_54:'',

    header_53:'',
    body_53:'',
	
    header_52:'',
    body_52:'',
	
    header_51:'',
    body_51:'',

    header_50:'Important Compatibility Notice (Android & Canada only) 14/07/2025',
    body_50:'A new version of mylife CamAPS FX 1.4 (189) is available. Please update the app via the Play Store. '
    + 'We recommend that you do not update your phone to OS 16 — it is not yet supported and may cause issues connecting to Glooko.',

    header_49:'',
    body_49:'',

    header_48:'',
    body_48:'',

    header_47:'',
    body_47:'',

    header_46:'',
    body_46:'',

    header_45:'',
    body_45:'',

    header_44:'',
    body_44:'',

    header_43:'',
    body_43:'',

    header_42:'',
    body_42:'',
	
    header_41:'',
    body_41:'',

    header_40:'',
    body_40:'',

    header_39:'',
    body_39:'',

    header_38:'',
    body_38:'',

    header_37:'',
    body_37:'',

    header_36:'',
    body_36:'',

    header_35:'',
    body_35:'',

    header_34:'',
    body_34:'',

    header_33:'',
    body_33:'',

    header_32:'',
    body_32:'',

    header_31:'',
    body_31:'',

    header_30:'',
    body_30:'',

    header_29:'',
    body_29:'',

    header_28:'',
    body_28:'',


    header_27:'',
    body_27:'',

    header_26:'',
    body_26:'',

    header_25:'',
    body_25:'',

    header_24:'',
    body_24:'',

    header_23:'',
    body_23:'',

    header_22:'',
    body_22:'',

    header_21:'',
    body_21:'',

    header_20:'',
    body_20:'',

    header_19:'',
    body_19:'',

    header_18:'',
    body_18:'',

    header_17:'',
    body_17:'',

    header_16:'',
    body_16:'',

    header_15:'',
    body_15:'',

    header_14:'',
    body_14:'',

    header_13:'',
    body_13:'',
    body_13_link_text:'',
    body_13_end: '',
    body_13_link:'',

    header_12:'',
    body_12:'',

    header_11:'',
    body_11:'',

    header_10:'',
    body_10:'',

    header_9:'',
    body_9:'',

    header_8:'',
    body_8:'',

    header_7:'',
    body_7:'',

    header_6:'',
    body_6:'',

    header_5:'',
    body_5:'',

    header_4:'',
    body_4:'',

    header_3:'',
    body_3:'',

    header_2:'',
    body_2:'',

    header_1:'',
    body_1:'',

};
